export default __webpack_public_path__ + "static/media/assetBasedFinance.7e88d5b5.webm";